@if (reportData()) {
  <div class="data-toolbar">
    <span class="entity-records-info">
      <span class="entity-list"
        >{{ 'entities.' + reportData().entity | translate }} {{ 'template.list' | translate }} &nbsp;&nbsp;&nbsp;
        {{ reportData()?.records?.length }}
      </span>
      @if (reportData().records.length > 1) {
        {{ 'recordPPT.records' | translate }}
      } @else {
        {{ 'recordPPT.record' | translate }}
      }
    </span>
    @if (!isUKFeaturesEnabled()) {
      <span>
        <a class="action-element" (click)="customizeColumns.emit(reportData().entity)">
          <mat-icon svgIcon="settings" aria-hidden="false"></mat-icon>
          <span>{{ 'template.customizeColumns' | translate }}</span>
        </a>
      </span>
    }
  </div>
}
